import { Injectable } from '@angular/core';
import { File } from './model/file';

import {ApiService} from '../../../core/service/api.service';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class FilesService {

    constructor(private api: ApiService) {
    }

    findFiles(criteria?: Object): Observable<File[]> {

        return this.api.get('files', criteria)
            .map( (row: Array<Object>) => {
                    return row.map(function (obj) {
                        const file = new File(obj);
                        return file;
                    })
                }
            );
    }

    findCountFiles(criteria?: Object): Observable<File[]> {

        return this.api.get('files-count', criteria)
            .map( (row: Array<Object>) => {
                    return row.map(function (obj) {
                        const file = new File(obj);
                        return file;
                    })
                }
            );
    }

    findFilesToDownload(criteria?: Object): Observable<File[]> {
        return this.api.get('files-to-download', criteria)
            .map( (row: Array<Object>) => {
                    return row.map(function (obj) {
                        const file = new File(obj);
                        return file;
                    })
                }
            );
    }
}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/files/components/files/files.service.ts